export function trackClick(eventName: string) {
  return (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const { href = '', textContent = '' } = event.target as HTMLAnchorElement

    window.dataLayer?.push({
      event: 'tracked-click',
      tracked_click_name: eventName,
      tracked_click_text: textContent,
      tracked_click_href: stripCurrentDomainFromHref(href),
    })
  }
}

function stripCurrentDomainFromHref(href: string) {
  const currentDomain = window.location.origin
  return href.replace(currentDomain, '')
}
